import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';
import { ThemeService } from 'Core/services';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class HeaderComponent {
  @Output() public collapse$: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() public isCollapsed!: boolean;

  constructor(protected readonly themeService: ThemeService) {}
}
